import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { CookieService } from 'ngx-cookie';
import { BuywifiService } from './buywifi.service';
import { TravelersService } from '../components/travelers/travelers.service';

@Injectable()
export class DatalayerService {

  public basicInformatin: object;
  public deviceDetails;
  public routing;
  public flightNumber;
  public flightType;
  constructor(private appService: AppService, private cookieService: CookieService, private travelersService: TravelersService,
    private buywifiService: BuywifiService) { }

  public pushInformationToDataLayer(page) {

    this.deviceDetails = this.appService.getFlightResponse();
    this.routing = `${this.deviceDetails.origin.iataCode}-${this.deviceDetails.destination.iataCode}`;
    this.flightNumber = this.deviceDetails.flightNumber;
    this.basicInformationGoingToPush(page);
    if (page === 'wifi-travelers') {
      this.addTravellersPageDetailsToDataLayer();
    } else if (page === 'wifi-keys') {
      this.addWifiKeysPageDetailsToDataLayer();
    } else if (page === 'wifi-payment') {
      this.addPaymentPageDetailsToDataLayer();
    } else if (page === 'wifi-confirmation') {
      this.addConfirmationPageDetailsToDataLayer();
    }
  }

  public basicInformationGoingToPush(currentpage) {
    const env = this.getEnvironment();
    let currentBreams;
    let prefOrigin, defaultCurrency;
    let page, homepage, flowTypeName;
    if (currentpage.split('-')[1] === 'keys') {
      currentBreams = currentpage;
    } else {
      currentBreams = currentpage.split('-')[1];
    }

    if (this.cookieService.get('_origin') !== null && this.cookieService.get('_origin') !== undefined) {
      prefOrigin = this.cookieService.get('_origin');
    }
    if (!prefOrigin) {
      prefOrigin = '';
    }
    if (currentpage !== 'wifi-travelers') {
      defaultCurrency = this.buywifiService.getCurrency();
    }

    const channel = this.appService.getChannel();
    const platformTypeName = (channel === 'WEB' ? 'desktop' : 'mobile');
    const CountryCode = this.appService.getPOS();
    const LanguageCode = this.appService.getLanguage();
    page = 'home|wifi|buy-wifi|' + currentBreams;
    homepage = currentpage;
    flowTypeName = 'buy-wifi-onboard';
    this.basicInformatin = {
      'environment': env,
      'platformType': platformTypeName,
      'pageBreadcrumb': page,
      'pageType': homepage,
      'siteCountry': CountryCode,
      'siteLanguage': LanguageCode,
      'preferredOrigin': prefOrigin,
      'currency': defaultCurrency || '',
      'flowType': flowTypeName,

    };

  }

  public getEnvironment() {
    let env;
    if (location.hostname.indexOf('beta.sas') >= 0 || location.hostname.indexOf('beta.flysas') >= 0 ||
      location.hostname.indexOf('www.sas') >= 0 || location.hostname.indexOf('www.flysas') >= 0 ||
      location.hostname.indexOf('d360l.flysas.com') >= 0) {
      env = 'prod';
    } else {
      env = 'staging';
    }
    return env;
  }

  public addTravellersPageDetailsToDataLayer() {
    const travellersDetails = {
      'onboard.leg.traveltimetotal': '',
      'onboard.leg.traveltimeleft': '',
      'onboard.leg.routing': this.routing,
      'onboard.leg.origin': this.deviceDetails.origin.iataCode,
      'onboard.leg.destination': this.deviceDetails.destination.iataCode,
      'onboard.flightNumber': this.flightNumber,
      'onboard.flighttype': this.getFlightType(),
      'event': 'view-wifi-travelers'
    };
    this.pushData(travellersDetails);
  }

  public addWifiKeysPageDetailsToDataLayer() {
    const wifiKeysPageDetails = {
      'onboard.travelers.adults': 1,
      'onboard.travelers.youths': 0,
      'onboard.travelers.children': 0,
      'onboard.travelers.infants': 0,
      'onboard.leg.routing': this.routing,
      'onboard.leg.origin': this.deviceDetails.origin.iataCode,
      'onboard.leg.destination': this.deviceDetails.destination.iataCode,
      'onboard.flightNumber': this.flightNumber,
      'onboard.flighttype': this.getFlightType(),
      'event': 'view-wifi-keys'
    }
    this.pushData(wifiKeysPageDetails);
  }

  public addPaymentPageDetailsToDataLayer() {
    const flowtype = { 'flowType': 'buy-wifi-onboard' };
    this.pushData(flowtype);
  }

  public addConfirmationPageDetailsToDataLayer() {
    let transId;
    if (this.appService.isCharter) {
      transId = this.travelersService.getCharterFormData().email;
    } else {
      transId = this.buywifiService.getPassengerResponse().bookingReference;
    }

    const confirmationPageDetails = {
      'event': 'purchase',
      'transactionAffiliation': 'SAS',
      'transaction.transactionId': transId, 	// booking reference
      'transaction.total': this.buywifiService.getSessionValue() * this.buywifiService.getCurrentPrice(), // total revenue
      'transaction.tax': '',	// total tax
      'transaction.currency': this.buywifiService.getCurrency(), // currency of transaction
      'transaction.customerCountry': '', // leave blank, legacy
      'transaction.customerZipCode': '', // leave blank, legacy
      'transaction.customerCity': '', // leave blank, legacy
      'transaction.campaignCode': '', // leave blank, legacy
      'transaction.products': [ // loop over all the products
        {
          'category': 'trip/extras/wifi-onboard',
          'name': 'Wifi onboard - ' + this.getFlightType(),
          'productRouting': this.routing, // new field, leg the purchase was made on
          'productName': '', // ticket type
          'quantity': this.buywifiService.getSessionValue(), // number of products bought
          'price': this.buywifiService.getSessionValue() * this.buywifiService.getCurrentPrice(), // price each
          'productId': '' // id of the product
        }],
      'pageType': 'purchase',
      'flowType': 'buy-wifi-onboard',
      'transaction.yq': ''
    };
    this.pushData(confirmationPageDetails);
  }

  public addChatEventToDatalayer() {
    this.checkDataLayerExistOrNot();
    const chatDataLayer = {
      'event': 'interaction',
      'interaction.category': 'Wifi onboard',
      'interaction.action': 'Support chat',
      'interaction.label': 'Open chat'
    }
    window['sasD360DataLayer'].push(chatDataLayer);
  }

  public checkDataLayerExistOrNot() {
    if (window['sasD360DataLayer'] === undefined || window['sasD360DataLayer'] === null) {
      (window as any).sasD360DataLayer = [];
    }
  }
  public pushData(dataToPush) {
    this.checkDataLayerExistOrNot();
    const dataoigntopush = Object.assign(dataToPush, this.basicInformatin);
    window['sasD360DataLayer'].push(dataoigntopush);
  }

  public activateDataLayer(label) {
    this.checkDataLayerExistOrNot();
    const chatDataLayer = {
      'event': 'interaction',
      'interaction.category': 'Wifi onboard',
      'interaction.action': 'Connect to wifi',
      'interaction.label': label
    }
    window['sasD360DataLayer'].push(chatDataLayer);
  }

  public postActivateDataLayerSuccess(segmentInfoMap, activateDeviceDataMap) {
    this.deviceDetails = this.appService.getFlightResponse();
    this.routing = `${this.deviceDetails.origin.iataCode}-${this.deviceDetails.destination.iataCode}`;
    this.flightNumber = this.deviceDetails.flightNumber;
    const activationData = {
      'onboard.connection.fullAccess': activateDeviceDataMap.get('connectionFullAccess'),
      'onboard.connection.type': activateDeviceDataMap.get('connectionType'),
      'onboard.leg.traveltimetotal': segmentInfoMap.get('traveltimetotal'),
      'onboard.leg.traveltimeleft': segmentInfoMap.get('traveltimeleft'),
      'onboard.leg.routing': this.routing,
      'onboard.leg.origin': this.deviceDetails.origin.iataCode,
      'onboard.leg.destination': this.deviceDetails.destination.iataCode,
      'onboard.flightNumber': this.flightNumber,
      'onboard.flighttype': this.getFlightType(),
      'event': 'wifi-onboard-connection-status'
    };
    this.pushData(activationData);
  }

  public postActivateDataLayerError(connectionType) {
    this.deviceDetails = this.appService.getFlightResponse();
    this.routing = `${this.deviceDetails.origin.iataCode}-${this.deviceDetails.destination.iataCode}`;
    this.flightNumber = this.deviceDetails.flightNumber;
    const activationData = {
      'onboard.connection.fullAccess': 'false',
      'onboard.connection.type': connectionType,
      'onboard.leg.routing': this.routing,
      'onboard.leg.origin': this.deviceDetails.origin.iataCode,
      'onboard.leg.destination': this.deviceDetails.destination.iataCode,
      'onboard.flightNumber': this.flightNumber,
      'onboard.flighttype': this.getFlightType(),
      'event': 'wifi-onboard-connection-status'
    };
    this.pushData(activationData);
  }

  public getDeviceDataLayer(statusCode) {
    this.checkDataLayerExistOrNot();
    this.deviceDetails = this.appService.getFlightResponse();
    this.routing = `${this.deviceDetails.origin.iataCode}-${this.deviceDetails.destination.iataCode}`;
    this.flightNumber = this.deviceDetails.flightNumber;
    let fullAccess = 'false';
    if (statusCode && statusCode === 'FULL') {
      fullAccess = 'true'
    }
    const deviceData = {
      'onboard.connection.fullAccess': fullAccess,
      'onboard.leg.routing': this.routing,
      'onboard.leg.origin': this.deviceDetails.origin.iataCode,
      'onboard.leg.destination': this.deviceDetails.destination.iataCode,
      'onboard.flightNumber': this.flightNumber,
      'onboard.flighttype': this.getFlightType(),
      'event': 'wifi-onboard-connection-status'
    };
    this.pushData(deviceData);
  }

  public getFlightType() {
    if (this.appService.getFlightResponse() && this.appService.getFlightResponse().flightType === 'charter') {
      this.flightType = 'charter';
    } else {
      this.flightType = 'commercial';
    }
    return this.flightType;
  }
}
